define('baseline/user-stats',["require", "exports", "../tracks/track", "../tracks/track-store", "../views/search-hint"], function (require, exports, track_1, trackStore, searchHint) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.init = void 0;
    function init(userId) {
        // Get user tracks and load into DOM
        trackStore.getUserTracks(userId).then(function (tracks) {
            // Compute stats
            var skyCount = tracks.filter(function (t) { return (0, track_1.jumpType)(t) === "Skydive"; }).length;
            var baseCount = tracks.filter(function (t) { return (0, track_1.jumpType)(t) === "BASE"; }).length;
            document.getElementById("user-stats-countries").innerHTML = countsHTML(tracks, function (t) { return t.place && t.place.country; });
            document.getElementById("user-stats-suits").innerHTML = countsHTML(tracks, function (t) { return t.suit; });
            document.getElementById("user-stats-types").innerHTML =
                "<tr><td>" + tracks.length + "</td><td>Total</td></tr>" +
                    ("<tr><td>" + baseCount + "</td><td class=\"search-hint\">BASE</td></tr>") +
                    ("<tr><td>" + skyCount + "</td><td class=\"search-hint\">Skydive</td></tr>");
        });
        searchHint.init();
    }
    exports.init = init;
    /**
     * Return sorted list of category counts
     */
    function countsHTML(tracks, key) {
        var counts = {};
        for (var _i = 0, tracks_1 = tracks; _i < tracks_1.length; _i++) {
            var track = tracks_1[_i];
            var category = key(track);
            if (category) {
                counts[category] = (counts[category] || 0) + 1;
            }
        }
        var pairs = [];
        for (var _a = 0, _b = Object.keys(counts); _a < _b.length; _a++) {
            var category = _b[_a];
            pairs.push([category, counts[category]]);
        }
        return pairs
            .sort(function (a, b) { return b[1] - a[1]; }) // Sort by count descending
            .map(function (pair) { return "<tr><td>" + pair[1] + "</td><td class=\"search-hint\">" + pair[0] + "</td></tr>"; })
            .join("");
    }
});
//# sourceMappingURL=/assets/javascripts/baseline/user-stats.js.map;
